/**
 * @fileoverview GET handler for the "/generative_ai/agents/agent_console_credit_ratios" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { agentConsoleCreditRatios } from "./constants";
import type { AgentConsoleCreditRatiosResult } from "./types";
import { isAgentConsoleCreditRatiosResult } from "./validators";

export const getAgentConsoleCreditRatios = reactQueryFetcherAdapter(
  agentConsoleCreditRatios,
  (signal: AbortSignal): Promise<AgentConsoleCreditRatiosResult> => {
    return fetch(agentConsoleCreditRatios, "GET", {}, { signal });
  },
  isAgentConsoleCreditRatiosResult
);
